import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./HelpPage.css";

const VIDEO_TABS = [
  {
    id: "fte",
    label: "FTE",
    title: "Как рассчитать FTE смены",
    description: "Инструкция по расчету FTE смены и работе с целевым FTE.",
    videoUrl: "https://rutube.ru/play/embed/af04918798ce684ce8770ca79ff73404",
    portalUrl: "/statistics?tab=general",
  },
  {
    id: "attendance",
    label: "Приход и уход",
    title: "Как контролировать время прихода и ухода сотрудников",
    description: "Инструкция по контролю опозданий и ранних уходов сотрудников.",
    videoUrl: "https://rutube.ru/play/embed/cdf962672dc0c178df13f4cf97181bb1",
    portalUrl: "/statistics?tab=general",
  },
  {
    id: "gantt",
    label: "Загруженность",
    title: "Как контролировать загруженность сотрудников",
    description: "Инструкция по работе с диаграммой Ганта и контролю загруженности.",
    videoUrl: "https://rutube.ru/play/embed/6a4445033484cfe37fcb3e6eb9602502",
    portalUrl: "/statistics?tab=gantt",
  },
  {
    id: "delivery-optimization",
    label: "Оптимизация доставки",
    title: "Оптимизация численности персонала доставки",
    description: "Инструкция по оптимизации численности персонала доставки.",
    videoUrl: "https://rutube.ru/play/embed/96af3c003bd824a2948209b0454641d3",
    portalUrl: "/statistics?tab=general",
  },
  {
    id: "shift-analysis",
    label: "Анализ смены",
    title: "Анализ смены и деятельности сотрудников",
    description: "Инструкция по анализу смены и деятельности сотрудников.",
    videoUrl: "https://rutube.ru/play/embed/d1fcde55574a033dc423a1ff93f8c7c2",
    portalUrl: "/statistics?tab=gantt",
  },
];

const INSTRUCTION_IDS = VIDEO_TABS.map((video) => video.id);

const TABS = [
  { id: "support", label: "Обращение в поддержку" },
  { id: "instructions", label: "Инструкции" },
  { id: "faq", label: "Частые вопросы" },
];

const FAQ_ITEMS = [
  {
    question: "Как изменить пароль?",
    answer: "Ответ появится позже.",
  },
  {
    question: "Как изменить email аккаунта?",
    answer: "Ответ появится позже.",
  },
  {
    question: "Как изменить тариф?",
    answer: "Ответ появится позже.",
  },
  {
    question: "Как подключить новые детекции?",
    answer: "Ответ появится позже.",
  },
  {
    question: "Как подключить новые камеры?",
    answer: "Ответ появится позже.",
  },
];

const getInitialTab = (tab) => {
  if (INSTRUCTION_IDS.includes(tab)) return "instructions";
  return TABS.some((item) => item.id === tab) ? tab : "support";
};

const HelpPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(getInitialTab(requestedTab));
  const [instructionSearch, setInstructionSearch] = useState("");
  const [openInstructionId, setOpenInstructionId] = useState(
    INSTRUCTION_IDS.includes(requestedTab) ? requestedTab : VIDEO_TABS[0].id
  );
  const [openFaqId, setOpenFaqId] = useState("");

  useEffect(() => {
    const nextTab = getInitialTab(requestedTab);
    if (nextTab !== activeTab) {
      setActiveTab(nextTab);
    }
    if (INSTRUCTION_IDS.includes(requestedTab)) {
      setOpenInstructionId(requestedTab);
    }
  }, [requestedTab, activeTab]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setSearchParams(tabId === "support" ? {} : { tab: tabId });
  };

  const filteredInstructions = VIDEO_TABS.filter((video) => {
    const query = instructionSearch.trim().toLowerCase();
    if (!query) return true;

    return [video.label, video.title, video.description].some((value) =>
      value.toLowerCase().includes(query)
    );
  });

  return (
    <div className="hp-container">
      <div className="hp-header">
        <h1>Помощь</h1>
      </div>

      <div className="hp-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`hp-tab ${activeTab === tab.id ? "hp-tab-active" : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="hp-content">
        {activeTab === "support" && (
          <div className="hp-support-section hp-support-section-simple">
            <div className="hp-support-info">
              <h3>Контактная информация</h3>
              <p>По вопросам поддержки напишите нам на email:</p>
              <div className="hp-contact-methods">
                <div className="hp-contact-method">
                  <h4>Email</h4>
                  <p>24inspector@mail.ru</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "instructions" && (
          <div className="hp-videos-section">
            <h2>Инструкции</h2>
            <p>Видеоинструкции и краткие описания по работе с ключевыми разделами статистики.</p>

            <div className="hp-search-row">
              <input
                type="search"
                value={instructionSearch}
                onChange={(event) => setInstructionSearch(event.target.value)}
                placeholder="Поиск по инструкциям"
              />
            </div>

            <div className="hp-accordion-list">
              {filteredInstructions.length === 0 ? (
                <div className="hp-empty-state">Инструкции не найдены</div>
              ) : filteredInstructions.map((video) => (
                <div key={video.id} className="hp-accordion-item">
                  <button
                    type="button"
                    className="hp-accordion-trigger"
                    onClick={() => setOpenInstructionId((currentId) => currentId === video.id ? "" : video.id)}
                  >
                    <span>{video.title}</span>
                    <span>{openInstructionId === video.id ? "−" : "+"}</span>
                  </button>

                  {openInstructionId === video.id && (
                    <div className="hp-accordion-body">
                      <p>{video.description}</p>
                      <div className="hp-single-video-card">
                        <div className="hp-video-player">
                          <iframe
                            src={video.videoUrl}
                            title={video.title}
                            frameBorder="0"
                            allow="clipboard-write; autoplay"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <a className="hp-portal-link" href={video.portalUrl}>
                        Перейти к разделу на портале
                      </a>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "faq" && (
          <div className="hp-faq-section">
            <h2>Часто задаваемые вопросы</h2>
            <p>Ответы на наиболее распространенные вопросы по работе с системой</p>

            <div className="hp-faq-list">
              {FAQ_ITEMS.map((item) => (
                <div key={item.question} className="hp-faq-item">
                  <button
                    type="button"
                    className="hp-faq-question"
                    onClick={() => setOpenFaqId((currentId) => currentId === item.question ? "" : item.question)}
                  >
                    <span>{item.question}</span>
                    <span>{openFaqId === item.question ? "−" : "+"}</span>
                  </button>
                  {openFaqId === item.question && <p>{item.answer}</p>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpPage;
